export enum PanelGroupTheme {
  Default = "DEFAULT",
  Grey = "GREY",
  Light = "LIGHT",
}
